import { z } from 'zod'

export const importKinds = [
  'members',
  'manual_games',
  'manual_leaderboards',
] as const
export type ImportKind = (typeof importKinds)[number]

export const importLineActions = ['created', 'matched', 'renamed'] as const
export type ImportLineAction = (typeof importLineActions)[number]

export const importFileMaxBytes = 5 * 1024 * 1024

export const importFileSchema = z.object({
  fileName: z
    .string()
    .trim()
    .min(1, '请选择文件')
    .max(200, '文件名过长')
    .refine((name) => name.toLowerCase().endsWith('.xlsx'), '请上传 .xlsx 文件'),
  fileBase64: z
    .string()
    .trim()
    .min(1, '请选择文件')
    .max(7_000_000, '文件过大'),
})

export type ImportFile = z.infer<typeof importFileSchema>

export const importFileSample: ImportFile = {
  fileName: '导入.xlsx',
  fileBase64: 'eA==',
}

export const importKindSchema = z.enum(importKinds, {
  error: '导入类型不合法',
})

export interface ImportBatchView {
  id: string
  kind: ImportKind
  kindLabel: string
  fileName: string
  createdCount: number
  matchedCount: number
  skippedCount: number
  createdAt: string
  createdByName: string
  undoneAt: string | null
}

export interface ImportBatchList {
  rows: ImportBatchView[]
}

export interface ImportBatchUndoResult {
  undone: true
  keptMemberCount: number
}